import styled from 'styled-components';
import { Table } from 'antd';

export const TableWrapper = styled(Table)`
	border-radius: 8px;
	overflow: hidden;
` as typeof Table;

export const TruncatedText = styled.div`
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-word;
`;
